/* eslint-disable no-template-curly-in-string */
import { ROUTES } from '../../../app/routes/routeMap';

const createLink = (template, shopId, subSection) => template
  .replace('${shopId}', shopId || '')
  .replace('${subSection}', subSection || '');

export const LinkPaths = {
  search: '/app/${shopId}/search/${subSection}',
  recs: '/app/${shopId}/recs/${subSection}',
  store: '/app/${shopId}/store/${subSection}',
  account: '/app/${shopId}/account/${subSection}',
};

export const Links = {
  // -------------------------------------------------------------------------
  // Canonical launch-critical routes — sourced from routeMap.js ROUTES builders
  // -------------------------------------------------------------------------
  home: ROUTES.home,
  setup: ROUTES.setup,
  diagnostics: ROUTES.diagnostics,

  // -------------------------------------------------------------------------
  // Legacy search sub-routes (preserved for existing usages outside the launch-critical scope)
  // -------------------------------------------------------------------------
  searchHome: (shopId) => createLink(LinkPaths.search, shopId, 'home'),
  searchOnboarding: (shopId) => createLink(LinkPaths.search, shopId, 'onboarding'),
  searchDashboard: (shopId) => createLink(LinkPaths.search, shopId, 'dashboard'),
  searchQueryPopular: (shopId) => createLink(LinkPaths.search, shopId, 'analytic/query-popular'),
  searchLostOpportunities: (shopId) => createLink(LinkPaths.search, shopId, 'analytic/lost-opportunities'),
  searchAnalyticsPopularProducts: (shopId) => createLink(LinkPaths.search, shopId, 'analytic/popular-products'),
  searchQueryNoResult: (shopId) => createLink(LinkPaths.search, shopId, 'analytic/query-no-result'),
  searchAnalyticsHealth: (shopId) => createLink(LinkPaths.search, shopId, 'analytic/health'),
  searchQueryDetail: (shopId, query = ':query') => createLink(
    LinkPaths.search,
    shopId,
    `analytic/query/${query === ':query' ? query : encodeURIComponent(query)}`,
  ),

  searchCustomizationFields: ROUTES.searchFields,
  searchCustomizationFilters: ROUTES.searchFilters,
  searchCustomizationSynonyms: ROUTES.searchSynonyms,
  searchCustomizationSuggestionOverrides: ROUTES.searchSuggestionOverrides,
  searchCustomizationTaxonomy: ROUTES.searchTaxonomy,
  searchCustomizationCardTemplate: (shopId) => createLink(LinkPaths.search, shopId, 'customization/card-template'),
  searchCustomizationEmptyQuery: (shopId) => createLink(LinkPaths.search, shopId, 'customization/empty-query'),
  searchMerchandisingRules: ROUTES.merchandisingRules,
  searchMerchandisingQueryRules: ROUTES.merchandisingQueryRules,
  searchMerchandisingProductRanking: ROUTES.merchandisingProductRanking,
  searchMerchandisingCategoryPriorities: ROUTES.merchandisingCategories,

  searchSettingsSearchbox: (shopId) => ROUTES.searchSettings(shopId, 'searchbox'),
  searchSettingsSearchMode: (shopId) => ROUTES.searchSettings(shopId, 'search-mode'),
  searchSettingsResultPage: (shopId) => ROUTES.searchSettings(shopId, 'result-page'),
  searchSettingsDropdown: (shopId) => createLink(LinkPaths.search, shopId, 'settings/dropdown'),
  searchSettingsTheme: (shopId) => ROUTES.searchSettings(shopId, 'theme'),
  searchSettingsData: (shopId) => ROUTES.searchSettings(shopId, 'data'),
  searchDataSettings: (shopId) => createLink(LinkPaths.search, shopId, 'data-settings'),
  searchDescriptionParameters: (shopId) => createLink(LinkPaths.search, shopId, 'settings/description-parameters'),
  searchCloudData: (shopId) => createLink(LinkPaths.search, shopId, 'settings/data-connectivity'),
  searchSettingsV2: (shopId) => createLink(LinkPaths.search, shopId, 'settings/v2'),
  searchCatalogHistory: (shopId) => createLink(LinkPaths.search, shopId, 'catalog-history'),
  searchAgentMcpSettings: (shopId) => createLink(LinkPaths.search, shopId, 'settings/ai'),
  searchStorefrontContent: (shopId) => createLink(LinkPaths.search, shopId, 'settings/storefront-content'),

  recsOnboarding: (shopId) => createLink(LinkPaths.recs, shopId, 'onboarding'),
  visualRecsOnboarding: (shopId) => createLink(LinkPaths.recs, shopId, 'visual_recs/onboarding'),
  recsDashboard: (shopId) => createLink(LinkPaths.recs, shopId, 'dashboard'),
  recsAnalyticsWidgets: (shopId) => createLink(LinkPaths.recs, shopId, 'analytics/widgets-performance'),
  recsCustomizationFields: (shopId) => createLink(LinkPaths.recs, shopId, 'customization/fields'),
  recsCustomizationWidgets: (shopId) => createLink(LinkPaths.recs, shopId, 'customization/widgets'),
  recsSettingsGeneral: (shopId) => createLink(LinkPaths.recs, shopId, 'settings/general'),
  recsSettingsTheme: (shopId) => createLink(LinkPaths.recs, shopId, 'settings/theme'),
  storeProducts: (shopId) => createLink(LinkPaths.store, shopId, 'catalog/product-catalog'),
  storeProductDetail: (shopId, productId) => createLink(
    LinkPaths.store,
    shopId,
    `catalog/product-catalog/${encodeURIComponent(productId)}`,
  ),
  storePopularProducts: (shopId) => createLink(LinkPaths.store, shopId, 'analytics/popular-products'),
  storeConversion: (shopId) => createLink(LinkPaths.store, shopId, 'analytics/conversion'),
  storeExperiment: (shopId) => createLink(LinkPaths.store, shopId, 'experiment'),
  accountSettings: (shopId) => createLink(LinkPaths.account, shopId, 'settings'),
  accountLogout: () => createLink(LinkPaths.account, null, '../../../signin'),
};
